

document.addEventListener('DOMContentLoaded', function () {
    if ($.fn.slick) { // Check if Slick is loaded
        $(".video-slider-inner").slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 2,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            pauseOnHover: true,
            pauseOnFocus: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1620,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        arrows: true,
                    },
                },
            ],
        });
        console.log("Slick slider initialized");
    } else {
        console.error("Slick is not loaded");
    }
});


